import React, { useState, useRef, useEffect } from "react";
import "./Login.css";
import "./BranchSelector.css";
import { SERVER_URL, NEW_PRINT } from "../config/config";
import { useHistory } from "react-router-dom";
import logo from "../assets/images/truck.jpg";

async function loginUser(credentials) {
  // https://run.mocky.io/v3/702e0d64-e1eb-4c63-b071-e4ad3e15acfc
  return fetch(SERVER_URL + "/login/access-token", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams(credentials),
  }).then((data) => data.json());
}

export default function BranchSelector({
  sessionObject,
  mainBranchSelector,
  subMenuItemsDict,
  setSubMenuItemsDict,
  setItemNamesDict,
}) {
  // console.log(mainBranchSelector);
  const [currentYear, setCurrentYear] = useState("");
  const [yearIndex, setYearIndex] = useState("");
  const [dateSelectorObj, setDateSelectorObj] = useState([]);
  const history = useHistory();
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();

  let refStoreObject = useRef({});
  var branch_info = sessionStorage.getItem("branch_info");
  var branch_info_1 = JSON.parse(branch_info)["branch_info"];
  // var branch_id = branch_info_1[0].branch_id;
  // var branch_name = branch_info_1[0].branch_name;
  // var branch_account_name = branch_info_1[0].account_name;
  // var branch_account_id = branch_info_1[0].account_id;
  const [branchInfo, setBranchInfo] = useState({
    branch_id: branch_info_1[0].branch_id,
    branch_name: branch_info_1[0].branch_name,
    branch_account_name: branch_info_1[0].account_name,
    branch_account_id: branch_info_1[0].account_id,
    branch_suffix: branch_info_1[0].suffix,
    branch_mobile: branch_info_1[0].mobile,
  });

  // const dateValueMapping = {
  //     1: "26-27",
  //     2: "25-26",
  //     3: "24-25",
  //     4: "23-24",
  //     5: "22-23",
  //     6: "21-22",
  //     7: "20-21",
  //     8: "19-20",
  //     9: "18-19",
  //     10: "17-18",
  //     11: "16-17",
  // }

  // const dateSelectorObj = [
  //     // {
  //     //     value: "26-27",
  //     //     label: "01/04/2026 - 31-03-2027"
  //     // },
  //     // {
  //     //     value: "25-26",
  //     //     label: "01/04/2025 - 31-03-2026"
  //     // },
  //     // {
  //     //     value: "24-25",
  //     //     label: "01/04/2024 - 31-03-2025"
  //     // },
  //     // {
  //     //     value: "23-24",
  //     //     label: "01/04/2023 - 31-03-2024"
  //     // },
  //     {
  //         value: "21-22",
  //         label: "01/04/2021 - 31/03/2022",
  //     },
  //     {
  //         value: "22-23",
  //         label: "01/04/2022 - 31/03/2023",
  //     },
  //     // {
  //     //     value: "20-21",
  //     //     label: "01/04/2020 - 31/03/2021",
  //     // },
  //     // {
  //     //     value: "26-27",
  //     //     label: "01/04/2018 - 31-03-2019"
  //     // },
  //     // {
  //     //     value: "26-27",
  //     //     label: "01/04/2017 - 31-03-2018"
  //     // },
  //     // {
  //     //     value: "26-27",
  //     //     label: "01/04/2016 - 31-03-2017"
  //     // },
  // ]

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${NEW_PRINT}/bilty/get_module_json/?client_name=${process.env.REACT_APP_CLIENT}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ client_name: process.env.REACT_APP_CLIENT }),
          redirect: "follow",
        },
      );

      const result = await response.json();
      let filteredModules = [...result.Modules];
      if (process.env.REACT_APP_CLIENT == "shubham") {
        if (sessionObject.sessionVariables.role_id !== 1) {
          filteredModules = filteredModules.filter(
            (module) => module.name !== "Bill Entry",
          );
        }
      }
      if (process.env.REACT_APP_CLIENT == "gdala_log") {
        if (sessionObject.sessionVariables.role_id !== 1) {
          filteredModules = filteredModules.filter(
            (module) => module.name !== "Station Wise Summary",
          );
        }
      }
      setSubMenuItemsDict({ ...result, Modules: filteredModules });
    } catch (error) {
      console.log("error", error);
    }
  };

  const fetchItemNames = async () => {
    try {
      const response = await fetch(`${SERVER_URL}/pack_type/`);
      const result = await response.json();
      setItemNamesDict(result);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchItemNames();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let financialYearObj = {
      financial_year: yearIndex,
    };

    if (mainBranchSelector) {
      financialYearObj.financial_year_for_fetch = yearIndex;
    }

    sessionObject.saveSessionVariableByObject({
      // branch_id: branch_id,
      // branch_name: branch_name,
      // branch_account_id: branch_account_id,
      // branch_account_name: branch_account_name,
      ...branchInfo,
      ...financialYearObj,
    });

    history.push("/");
  };

  const handleChange = function (e, selectName) {
    const { name, value } = e.target;
    let curr_branch_id = value;
    for (let i = 0; i < branch_info_1.length; i++) {
      if (branch_info_1[i].branch_id == curr_branch_id) {
        setBranchInfo({
          branch_id: value,
          branch_name: branch_info_1[i].branch_name,
          branch_account_name: branch_info_1[i].account_name,
          branch_account_id: branch_info_1[i].account_id,
          branch_suffix: branch_info_1[i].suffix,
          branch_mobile: branch_info_1[i].mobile,
        });
      }
    }
  };

  useEffect(
    // Effect for clearing out client side validation
    () => {
      refStoreObject.current["branch_select"].focus();
    },
    [],
  );

  useEffect(() => {
    let selectorObj = [];

    const currDate = new Date();
    let currMonth = currDate.getMonth() + 1;
    let currYear =
      currDate.getFullYear().toString().substring(2) - (currMonth < 4);

    console.log(sessionObject.sessionVariables);
    let yearRange = 2;
    let isCurrentYearSet = false;

    if (currYear == "21") {
      selectorObj.push({
        value: "22-23",
        label: "01/04/2022 - 31/03/2023",
      });
    }

    for (let i = 0; i < yearRange; i++) {
      let temp1 = currYear - i;
      let temp2 = temp1 + 1;
      let tempObj = {
        value: temp1 + "-" + temp2,
        label: "01/04/20" + temp1 + " - " + "31/03/20" + temp2,
      };

      if (!isCurrentYearSet) {
        isCurrentYearSet = true;
        setCurrentYear(temp1 + "-" + temp2);
        setYearIndex(temp1 + "-" + temp2);
      }

      selectorObj.push(tempObj);
    }
    setDateSelectorObj(selectorObj);
    // console.log(branchInfo, yearIndex);
  }, []);

  // React.useEffect(() => {
  //     console.log({ currentYear});
  // })

  const handleBackToLogin = () => {
    try {
      if (
        sessionObject &&
        typeof sessionObject.saveSessionVariableByField === "function"
      ) {
        sessionObject.saveSessionVariableByField("access_token", "");
      } else {
        sessionStorage.removeItem("access_token");
      }
    } catch (e) {
      sessionStorage.removeItem("access_token");
    }

    history.push("/");
  };

  return (
    <div className="branch-wrapper" style={{ backgroundImage: `url(${logo})` }}>
      <div className="branch-card">
        <button
          type="button"
          className="branch-back-btn"
          onClick={handleBackToLogin}
          onKeyDown={(e) => {
            if (e.key === "Enter") e.currentTarget.click();
          }}
          aria-label="Back to login"
        >
          ← Back to login
        </button>

        <div className="branch-icon">🏦</div>

        <div className="branch-title">Select Branch</div>
        <div className="branch-subtitle">Choose your branch and year</div>

        <form onSubmit={handleSubmit}>
          <select
            className="branch-select"
            ref={(a) => (refStoreObject.current.branch_select = a)}
            onChange={(e) => handleChange(e)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                refStoreObject.current.year_select.focus();
              }
            }}
          >
            {branch_info_1.map((branch) => (
              <option value={branch.branch_id} key={branch.branch_id}>
                {branch.branch_name}
              </option>
            ))}
          </select>

          <select
            className="branch-select"
            value={yearIndex}
            ref={(a) => (refStoreObject.current.year_select = a)}
            onChange={(e) => setYearIndex(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                refStoreObject.current.save_button.focus();
              }
            }}
          >
            {dateSelectorObj.map((date) => (
              <option value={date.value} key={date.value}>
                {date.label}
              </option>
            ))}
          </select>

          <button
            type="submit"
            ref={(a) => (refStoreObject.current.save_button = a)}
            className="branch-submit-btn"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}
